module.exports = __webpack_public_path__ + "img/image-thumb-1.24b160a2.jpg";